import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent {
  constructor(public translate: TranslateService) {}

  changeTranslation(val: string): void {
    console.log(val);
    this.translate.use(val);
    localStorage.setItem('locale', val);
  }
}
